import type { UserDto } from '../api/generated/model';

export const AVATAR_COLORS = ['primary', 'neutral', 'success', 'warning', 'danger'] as const;

export function getInitials(user: UserDto) {
  const first = user.firstName?.charAt(0) ?? '';
  const last = user.lastName?.charAt(0) ?? '';
  const initials = `${first}${last}`.toUpperCase();
  if (initials) return initials;
  return (user.username ?? user.email ?? '?').charAt(0).toUpperCase();
}

export function getUserLabel(user: UserDto) {
  const name = `${user.lastName ?? ''} ${user.firstName ?? ''}`.trim();
  return name || user.username || user.email || user.id;
}

export function getAvatarColor(userId: string) {
  let hash = 0;
  for (let i = 0; i < userId.length; i++) {
    hash = (hash * 31 + userId.charCodeAt(i)) & 0xffffffff;
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export function resolveChangedByName(changedBy: string, users: UserDto[]) {
  const user = users.find((candidate) => candidate.id === changedBy);
  if (!user) {
    return changedBy;
  }

  if (user.firstName && user.lastName) {
    return `${user.firstName} ${user.lastName}`;
  }

  return user.email || changedBy;
}
